import Table from '../../components/ui/Table'
import Dropdown from '../../components/ui/Dropdown'
import { formatCurrency, formatDate } from '../../lib/format'

function TransactionRow({ transaction, onEdit, onDelete, showBusiness = false }) {
  const isExpense = transaction.type === 'expense'

  return (
    <Table.Row>
      <Table.Cell>
        {formatDate(transaction.date)}
      </Table.Cell>
      <Table.Cell>
        <div>
          <div className="font-medium">{transaction.description}</div>
          {transaction.notes && (
            <div className="text-sm text-muted">{transaction.notes}</div>
          )}
        </div>
      </Table.Cell>
      {showBusiness && (
        <Table.Cell>
          {transaction.businesses && (
            <span>
              {transaction.businesses.emoji} {transaction.businesses.name}
            </span>
          )}
        </Table.Cell>
      )}
      <Table.Cell>
        <span className="text-muted">{transaction.category || '—'}</span>
      </Table.Cell>
      <Table.Cell style={{ textAlign: 'right' }}>
        <span className={`amount ${isExpense ? 'negative' : 'positive'}`}>
          {isExpense ? '-' : '+'}{formatCurrency(transaction.amount)}
        </span>
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          trigger={
            <button className="btn btn-ghost btn-sm">⋯</button>
          }
        >
          <Dropdown.Item onClick={() => onEdit(transaction)}>
            ✏️ Edit
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => onDelete(transaction.id)} danger>
            🗑️ Delete
          </Dropdown.Item>
        </Dropdown>
      </Table.Cell>
    </Table.Row>
  )
}

export default TransactionRow
